export default __webpack_public_path__ + "static/media/treasure_2025.d1a468ec.jpg";